module.exports = __webpack_public_path__ + "static/media/tick-tock.8d393ce7.mp3";